import type { IconSvgObject } from './types';

const WpsOfficeRectangleIcon: IconSvgObject = [
  ["path", { d: "M13.3274 14.4152L14.1 16H14.5L18 8.5V8H13.8L12 11.6923L9.9 16H9.5L6 8.5V8H10.2L10.6875 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.5 4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V4.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WpsOfficeRectangleIcon;
